<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="generalPagePaddingH">
                <header class="header paddingV16">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey10 fWeight600">下单即获优惠券</div>
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                    </div>
                </header>
                <div class="body hiddenScrollbar" style="margin-top: 10px; padding-bottom: 34px; height: 320px; overflow: auto">
                    <div class="roll_list" style="width:100%;height:272px;display: flex;justify-content: center;align-items: center;" v-if="dataList.join('') === '当前活动不可能用！'">
                        暂无优惠券！
                    </div>
                    <div v-else class="roll_list">
                        <div class="roll_item" style="width: 100%;"
                             v-for="(item , index) in dataList" :key="index">
                            <div class="roll_left">
                                <div style="font-size:16px;margin-bottom:15px;">{{item.name}}</div>
                                <div class="roll_explam">{{item.explain}}</div>
                                <div style="font-size:14px;">{{formatDate(item.startTime)}}-{{formatDate(item.endTime)}}到期</div>
                            </div>
                            <div style="text-align:center;line-height:100px;" class="roll_right">
                                <div>
                                    <span class="roll_unit">￥</span>
                                    <span class="roll_price">{{item.creditAmount}}</span>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <footer class="footer" style="padding: 8px 0 37px;">
                    <button class="closeButton white font16r" @click="close();">关闭</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// style
import '@/components/coupon/coupon.scss';
import '@comp/coupon/cardroll.scss';

// util
import consoleHelper from '@util/consoleHelper';

const config = {
    apiConfig : {
        list : {
            url : "portal/v4/go/getActivityCouponInfo",
            dataPath : 'data',
            totalPagePath : 'data.pages',
            params : {
                // activityId : '' // required
            },
            dataColumnMapping : {
                // userName : 'name''
            }
        },
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "couponDrawer",
    extends : shixunPagePart,
    data() {
        return {
            apiConfig : config.apiConfig,
            enableDataList : true,
            // autoLoadDataList : true,
            scrollToLoadNextPage : false,
            pageSize : 100
        }
    },
    methods : {
        updateDataList(options = {}) {
            this.apiConfig.list.params = options;
            this.reloadDataList();
        },
        formatDate(timestamp){
            let time = new Date(timestamp)
            var year = time.getFullYear()
            var month = time.getMonth() + 1
            var day = time.getDate()

            if(year<10){

                year = '0'+year
            }

            if(month<10){
                month =  '0'+month
            }
            if(day<10){
                day = '0'+day
            }
            return year+'.'+month+'.'+day

        },
    }
}
</script>

<style lang="scss" scoped>
.header {

    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.closeButton {
    display: block;
    width: 100%;
    padding: 0;
    background: hsla(0, 100%, 61%, 1);
    height: 42px;
    line-height: 42px;
    border-radius: 21px;
    border: none;
}

</style>
